import {Theme} from "@mui/material";

export const sortableStyles = {
    sortableItem: {
        sortableItemContainer: {
            padding: 1,
            marginBottom: 2,
            borderRadius: "8px",
            backgroundColor: "#fff",
        },
        dragger: {
            cursor: "grab",
            display: "flex",
            padding: 1,
        }
    },
    sortableBox:{
      pl: 4
    },
    sortableDraggingBox:{
        position: "absolute",
        top: (theme: Theme) => theme.spacing(3.1),
        left: (theme:Theme) => theme.spacing(2),
        color: "text.secondary",
        cursor: "grab",
        "&:active": { cursor: "grabbing" },
        "&:hover": { color: "text.primary" },
        display: "flex",
        alignItems: "center",

    }
}
